import { useApp } from '../context.js';
import { Star } from '../icons.jsx';

export default function QuickStats() {
    const { activeRestaurantCount, averageRating, ratedCount, t } = useApp();
    return (
        <div className="grid grid-cols-3 gap-3 mb-4">
            <div className="bg-white/90 apple-card rounded-2xl p-3 shadow-md">
                <div className={`text-2xl font-bold ${t.accentText}`}>{activeRestaurantCount}</div>
                <div className="text-xs text-gray-600">Places</div>
            </div>
            <div className="bg-white/90 apple-card rounded-2xl p-3 shadow-md">
                <div className="text-2xl font-bold text-green-600">
                    {ratedCount}
                </div>
                <div className="text-xs text-gray-600">Rated</div>
            </div>
            <div className="bg-white/90 apple-card rounded-2xl p-3 shadow-md">
                <div className={`text-2xl font-bold ${t.statColor} flex items-center justify-center gap-1`}>
                    {averageRating}
                    <Star size={16} className="text-yellow-500 fill-yellow-500" />
                </div>
                <div className="text-xs text-gray-600">Average</div>
            </div>
        </div>
    );
}
